// React, Next
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

// Custom
import PillarSection, { PillarItem } from './PillarSection'
import { translateHref } from 'assets/functions/links'

// Config
import i18nextConfig from 'next-i18next.config'

// Img
import PillarImage from 'public/img/services/industrial_it.webp'

// Style
import themeColors from 'assets/theme/colors'

export default function IndustrialIotSection() {
  const { t } = useTranslation('index')

  const router = useRouter()
  const currentLocale = router.query.locale || i18nextConfig.i18n.defaultLocale

  const items: PillarItem[] = [
    {
      title: t('industrialIot.items.01.title'),
      paragraphs: [
        t('industrialIot.items.01.p1'),
        t('industrialIot.items.01.p2')
      ]
    },
    {
      title: t('industrialIot.items.02.title'),
      paragraphs: [
        t('industrialIot.items.02.p1'),
        t('industrialIot.items.02.p2')
      ]
    },
    {
      title: t('industrialIot.items.03.title'),
      paragraphs: [
        t('industrialIot.items.03.p1'),
        t('industrialIot.items.03.p2')
      ],
      link: {
        label: t('industrialIot.items.03.link'),
        href: translateHref(currentLocale, 'test-equipment-modernization')
      }
    }
  ]

  // *** MAIN RENDER ***
  return (
    <PillarSection
      eyebrow={t('industrialIot.eyebrow')}
      title={t('industrialIot.title')}
      paragraphs={[t('industrialIot.p1'), t('industrialIot.p2')]}
      image={PillarImage}
      imageSide="left"
      items={items}
      background={themeColors.kroemtech.background}
      cardBackground={themeColors.section.light}
    />
  )
}
